import { formatDate } from "../../../helpers/date";

export const PROJECT_PROGRESS_COLUMNS = [
  {
    Header: "Name",
    id: "name",
    accessor: "name",
    minWidth: 250
  },
  {
    Header: "Dept.",
    id: "department",
    accessor: "department",
    maxWidth: 50
  },
  {
    Header: "Category",
    id: "category",
    accessor: "category",
    maxWidth: 85
  },
  {
    Header: "Customer",
    id: "customer",
    accessor: "customer"
  },
  {
    Header: "Call Type",
    id: "callType",
    accessor: "callType"
  },
  {
    Header: "Status",
    id: "projectStatus",
    accessor: "projectStatus"
  },
  {
    Header: "Project Manager",
    id: "projectManager",
    accessor: "projectManager"
  },
  {
    Header: "Primary Resource",
    id: "primaryResource",
    accessor: "primaryResource"
  },
  {
    Header: "Start Date",
    id: "startDate",
    accessor: "startDate",
    Cell: ({ value }) => (value ? formatDate(value, "MM/dd/yyyy") : "--")
  },
  {
    Header: "End Date",
    id: "endDate",
    accessor: "endDate",
    Cell: ({ value }) => (value ? formatDate(value, "MM/dd/yyyy") : "--")
  },
  {
    Header: "Expected End Date",
    id: "expectedEndDate",
    accessor: "expectedEndDate",
    Cell: ({ value }) => (value ? formatDate(value, "MM/dd/yyyy") : "Ongoing")
  },
  {
    Header: "Progress",
    id: "progress",
    accessor: "progress",
    maxWidth: 100,
    Cell: ({ value }) => `${value}%`
  },
  {
    Header: "Budget Amount",
    id: "budgetAmount",
    accessor: "budgetAmount",
    maxWidth: 120,
    Cell: ({ value }) => {
      if (value) {
        return `$${value}`;
      }
      return "$0.00";
    }
  },
  {
    Header: "Budget Hours",
    id: "budgetHours",
    accessor: "budgetHours",
    maxWidth: 140,
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00"
  },
  {
    Header: "Billable Hours",
    id: "billableHours",
    accessor: "billableHours",
    maxWidth: 100,
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00"
  },
  {
    Header: "Actual Hours",
    id: "actualHours",
    accessor: "actualHours",
    maxWidth: 100,
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00"
  },

  {
    Header: "Latest User Note",
    id: "latestUserNote",
    accessor: "latestUserNote",
    Cell: ({ value }) => {
      const el = document.createElement("div");
      el.innerHTML = value;
      return el.textContent;
    },
    minWidth: 100
  },
  {
    Header: "Latest System Note",
    id: "latestSystemNote",
    accessor: "latestSystemNote",
    Cell: ({ value }) => {
      const el = document.createElement("div");
      el.innerHTML = value;
      return el.textContent;
    },
    minWidth: 100
  }
];
